'use strict';

angular.module('imagetrend.components')
    .directive('hlpTextarea', ['$timeout', 'Format', 'Validation', function ($timeout, Format, Validation) {
        return {
            restrict: 'AE',
            scope: {
                ngModel: '=',
                question: '=',
                validation: '=?',

                //attributes
                name: '@?',
                id: '@?',
                classes: '@?',
                cols: '@?',
                rows: '@?',
                maxLength: '@?',
                modal: '@?',
                placeholder: '@?',

                //disabled
                isDisabled: '=?',

                //required
                isRequired: '=?',
                showRequired: '=?',
                requiredText: '@?',

                //label
                showLabel: '@?',
                topLabel: '=?',
                label: '@?',
                title: '@?',

                //instructions
                instructions: '@?',
                showColon: '=?',
                pdf: '=?',
                completed: '=?',
                saving: '=?'
            },
            require: 'ngModel',
            replace: true,
            transclude: true,
            templateUrl: 'templates/textarea/textarea.html',
            controller: ['$scope', '$timeout', function ($scope, $timeout) {
                $scope.validate = function () {
                    if ($scope.innerForm !== undefined) {
                        if ($scope.validation) {
                            Validation.validateQuestion($scope.innerForm.textarea, $scope.validation, $scope.ngModel);
                        }
                        if ($scope.question !== undefined && $scope.question.answer !== undefined) {
                            $scope.question.answer.invalid = !isEmpty($scope.innerForm.textarea.$error);
                        }
                    }
                }
                var validationTimeout = $timeout(function () {
                    if (!$scope.requiredText) {
                        $scope.requiredText = 'Please enter a ' + Format.label(($scope.label || $scope.name));
                    }
                    $scope.validate();
                }, 0);

                $scope.$on('$destroy', function () {
                    $timeout.cancel(validationTimeout);
                });
            }],
            link: function (scope, elem, attrs, ctrl) {
                scope.timeouts = [];

                //attributes
                if (!attrs.id) { attrs.id = attrs.name; }
                if (!attrs.cols) { attrs.cols = '60'; }
                if (!attrs.rows) { attrs.rows = '5'; }
                if (!attrs.modal) { attrs.modal = false; } else { if (attrs.modal == 'true') { attrs.modal = true; } else { attrs.modal = false; } }
                if (!attrs.maxLength) { attrs.maxLength = '5000'; } else { if (attrs.maxLength == '') attrs.maxLength = '5000'; }

                //label
                if (!attrs.name) { attrs.name = 'textarea'; }
                if (!attrs.label) { attrs.label = Format.label(attrs.name); }
                if (!attrs.showLabel) { attrs.showLabel = attrs.label.length > 0; } else { if (attrs.showLabel == 'true') { attrs.showLabel = true; } else { attrs.showLabel = false; } }
                if (!attrs.title) { attrs.title = attrs.label; }
                if (!attrs.topLabel) { attrs.topLabel = false; } else { if (attrs.topLabel == true || attrs.topLabel == 'true') { attrs.topLabel = true; } else { attrs.topLabel = false; } }
                if (!attrs.showColon) { attrs.showColon = true; } else { if (attrs.showColon == true || attrs.showColon == 'true') { attrs.showColon = true; } else { attrs.showColon = false; } }

                //required
                //if (!attrs.isRequired) { attrs.isRequired = false; } else { if (attrs.isRequired == 'true') { attrs.isRequired = true; } else { attrs.isRequired = false; } }

                scope.onChange = function (item) {
                    scope.submitted = false;
                    ctrl.$setViewValue(item);
                    if (scope.validation) {
                        Validation.validateQuestion(scope.innerForm.textarea, scope.validation, scope.ngModel);
                    }
                    if (scope.question !== undefined && scope.question.answer !== undefined) {
                        scope.question.answer.invalid = !isEmpty(scope.innerForm.textarea.$error);
                    }
                }

                scope.submitted = false;
                scope.$on('form:submit', function () {
                    scope.validate();
                    scope.submitted = true;
                });

                scope.$on('$destroy', function () {
                    scope.timeouts.forEach(function (timer) {
                        $timeout.cancel(timer);
                    });
                });
            }
        };
    }])
;